import {ValueObject} from '@s-ui/domain'

export class ContactEnrichmentSellerValueObject extends ValueObject {
  #buyerIntentions
  #isDefaultMessage

  constructor({buyerIntentions, isDefaultMessage}) {
    super()
    this.#buyerIntentions = buyerIntentions
    this.#isDefaultMessage = isDefaultMessage
  }

  static create({buyerIntentions, isDefaultMessage} = {}) {
    return new ContactEnrichmentSellerValueObject({
      buyerIntentions: buyerIntentions || [],
      isDefaultMessage
    })
  }

  getEnrichment() {
    return {
      buyerIntentions: this.#buyerIntentions.value,
      isDefaultMessage: this.#isDefaultMessage
    }
  }
}
